// config
const resolveDefaultOrigin = () => {
  if (typeof window !== "undefined" && window.location) {
    const { hostname, port, protocol, origin } = window.location;
    if (hostname === "localhost" && port === "3000") {
      return "https://localhost:8080";
    }
    if (hostname === "127.0.0.1" && port === "3000") {
      return "https://127.0.0.1:8080";
    }
    if (origin) {
      return origin;
    }
    return `${protocol}//${hostname}`;
  }
  return "https://localhost:8080";
};

const defaultBaseSoundURL = resolveDefaultOrigin();
const defaultBaseURL = `${defaultBaseSoundURL}/api`;

declare global {
  interface Window {
    __APP_CONFIG__?: {
      REACT_APP_BASE_URL?: string;
      REACT_APP_BASE_SOUND_URL?: string;
    };
  }
}

const fromRuntime =
  typeof window !== "undefined" ? window.__APP_CONFIG__ : undefined;
export const baseURL =
  fromRuntime?.REACT_APP_BASE_URL ??
  process.env.REACT_APP_BASE_URL ??
  defaultBaseURL;
export const baseSoundURL =
  fromRuntime?.REACT_APP_BASE_SOUND_URL ??
  process.env.REACT_APP_BASE_SOUND_URL ??
  defaultBaseSoundURL;
